// removed by extract-text-webpack-plugin
module.exports = {"main":"_2GQZppGgz3iILtwx1Pcq_E","value":"_3DrmzXQcB0kTOJOYsjMzSt"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/CustomersProfiles/TableHeader.module.css
// module id = 2342
// module chunks = 1